import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { DEFAULT_FILTER_COMPLICITIES_QUERY_PARAMS } from "../api";
import ComplicityForm from "../components/forms/ComplicityForm";
import { ComplicityFilterView } from "../components/views/ComplicityFilterView";
import ComplicityTableView from "../components/views/ComplicityTableView";
import { Complicity, ComplicityFilterPageRequest } from "../types";

export const ComplicityListContainer = () => {
  const [complicityFormOpen, setComplicityFormOpen] = useState(false);
  const [complicityToUpdate, setComplicityToUpdate] = useState<Complicity>();

  const searchParams = useFilterSearchParams<ComplicityFilterPageRequest>({
    params: ["institutionIds"],
    defaultQueryParamsObject: DEFAULT_FILTER_COMPLICITIES_QUERY_PARAMS,
  });

  const handleCreateClick = () => {
    setComplicityFormOpen(true);
  };

  const handleUpdateClick = (complicity: Complicity) => {
    setComplicityFormOpen(true);
    setComplicityToUpdate(complicity);
  };

  const handleFormCancel = () => {
    setComplicityFormOpen(false);
    setComplicityToUpdate(undefined);
  };

  return (
    <ContentWrapper>
      <ComplicityFilterView searchParams={searchParams} onCreateClick={handleCreateClick} />

      <ComplicityTableView searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <ComplicityForm complicity={complicityToUpdate} open={complicityFormOpen} onFormCancel={handleFormCancel} />
    </ContentWrapper>
  );
};
